export default "<div id=\"{{this.chartID}}\"></div>\r\n"